/*
 * PROD-7828 D10 — "deleted account with money due" made impossible to miss: the Teacher Payments banner, the
 * Bank payouts badge, the Deleted accounts section label and the teacher profile banner. I/O-free.
 */
import { hasAccess } from '../../../../util_functions';
import { fmt } from '../format';

export const DELETED_VIEW = 'deleted';

// The payouts routes' roles (goserver canReviewPayoutDetails): anyone else would only collect 403s.
export const can_see_deleted_accounts = (access_type) =>
  hasAccess(access_type, 'TEACHER_OPS_PAYMENT', 'TEACHER_PAYMENT_SUPER_USER');
export const PAYOUT_VIEW_KEYS = ['file', 'response', 'held', 'claims', DELETED_VIEW, 'holidays'];
// Where every banner points: the Bank payouts tab opened on its Deleted accounts section.
export const DELETED_ACCOUNTS_PATH = '/teacher-payments/bank-payouts';
export const DELETED_ACCOUNTS_LINK = `${DELETED_ACCOUNTS_PATH}?view=${DELETED_VIEW}`;

const count_of = (v) => (Number.isInteger(v) && v > 0 ? v : 0);

// GET /payouts/deleted_accounts/summary -> {count, complete}; anything malformed reads as nothing due.
export const deleted_summary_view = (data) => ({
  count: count_of(data && data.count),
  complete: !data || data.complete !== false
});

// The page banner, or null when nothing is due. A partial server scan means "at least N".
export const deleted_banner_text = (view) => {
  const n = count_of(view && view.count);
  if (!n) return null;
  const shown = view.complete === false ? `${n}+` : String(n);
  return n === 1 && view.complete !== false
    ? '1 deleted account has money due'
    : `${shown} deleted accounts have money due`;
};

// "Deleted accounts (3)" on the section button; the plain label when none.
export const deleted_section_label = (label, count) =>
  count_of(count) ? `${label} (${count_of(count)})` : label;

// ?view= on the Bank payouts URL, whitelisted; null when absent or unknown.
export const payouts_view_from_search = (search) => {
  const v = new URLSearchParams(typeof search === 'string' ? search : '').get('view');
  return PAYOUT_VIEW_KEYS.indexOf(v) !== -1 ? v : null;
};

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// '2026-10-14' -> '14 Oct 2026', split by hand: the value is a zoneless IST day.
const day_label = (day) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day || '');
  return m ? `${Number(m[3])} ${MONTHS[Number(m[2]) - 1]} ${m[1]}` : '';
};

// Whole rupees unless there are paise.
const rupees = (v) => fmt(v, Number.isInteger(v) ? 0 : 2);

// GET /payouts/deleted_accounts/teacher -> the profile banner text, or null (not deleted, or nothing due).
export const deleted_teacher_banner = (data) => {
  const due = data && data.money_due;
  if (!data || data.deleted !== true || !due || due.has_money_due !== true) return null;
  if (typeof due.total !== 'number' || due.total <= 0) return null;
  const day = day_label(data.deleted_on);
  return day
    ? `Account deleted on ${day} with ${rupees(due.total)} due`
    : `Account deleted with ${rupees(due.total)} due`;
};
